module.exports = __webpack_public_path__ + "static/media/explore-section1-icon.49c27e5d.png";